import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45e95aa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xr-debug-view" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Reset Game")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Back to home")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Start again")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("View Map")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("View Map / Exit")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Exit Session")
const _hoisted_8 = { key: 3 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Display introduction text on the wall", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Skip Intro")
const _hoisted_11 = { key: 4 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Move around", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Move")
const _hoisted_14 = { key: 5 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Crouch", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Crouch")
const _hoisted_17 = { key: 6 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Aim door", -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Aim door")
const _hoisted_20 = { key: 7 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Open door", -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Open door")
const _hoisted_23 = { key: 8 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Exit the room", -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Exit Guest room")
const _hoisted_26 = { key: 9 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Send emoji", -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Send emoji")
const _hoisted_29 = { key: 10 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: null
}, "Select hotspot", -1))
const _hoisted_31 = ["value"]
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Click hotspot")
const _hoisted_33 = { key: 11 }

import { ref, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n';

import { useHotspots } from '@/services/stores/hotspots';
import { RoomLevelId } from '@webgl/entities/Room';
import { getDoorStepPosition, getNextStepPosition } from '@/services/states/GameContextDatas'
import { useAppState, useGameState, useNetworkState } from '@/services/composition';
import Delay from '@/core/Delay';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n()
const { send } = useAppState()
const { hotspots, findHotspot } = useHotspots()

const state = useGameState()
const nwState = useNetworkState()

const roomId = computed(() => {
  return nwState.value.context.roomid
})

const hotspotSelected = ref(null)

const currentHotspots = computed(() => {
  return hotspots.filter(hotspot => hotspot.states.some(hState => state.value.matches(hState)) && !state.value.context.hotspots.includes(hotspot.id))
})

const exitGuestRoom = () => {
  const position = getNextStepPosition(state.value)
  send({ type: 'GAME_MOVE_PLAYER', payload: position})
  // send('GAME_ACTION_DONE')
}

const isExit = computed(() => {
   return state.value.matches('tuto.xr.exit_room') || state.value.matches('game.bedroom.exit_room') || state.value.matches('game.corridor.exit_room') || state.value.matches('game.studyroom.exit_room') || state.value.matches('game.living.exit_room')
})

watch(isExit, (isExit) => {
  if(isExit && !state.value.matches('tuto')) {
    const position = getNextStepPosition(state.value)
    send({ type: 'GAME_MOVE_PLAYER', payload: position})
  }
})

const clickHotspot = async () => {
  if (hotspotSelected.value === null) return

  const hotspot = findHotspot(hotspotSelected.value)

  if (isExit.value) {
    const position = getNextStepPosition(state.value)
    send({ type: 'GAME_MOVE_PLAYER', payload: position})
    // send({ type: 'GAME_ACTION_DONE' })
    hotspotSelected.value = null
    return
  }

  if (hotspot.isDoor) {
    const position = getDoorStepPosition(state.value)
    send({ type: 'GAME_MOVE_PLAYER', payload: position})
    await Delay(1000)
    send({ type: 'GAME_ACTION_DONE' })
    hotspotSelected.value = null
    return
  }

  send({ type: 'GAME_HOTSPOT_ACTION_DONE', payload: hotspotSelected.value })
  hotspotSelected.value = null
}

return (_ctx: any,_cache: any) => {
  const _component_ui_btn = _resolveComponent("ui-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, "Game state : " + _toDisplayString(_unref(state).value), 1),
    _createElementVNode("p", null, "Level : " + _toDisplayString(_unref(RoomLevelId)[_unref(state).context.roomlevel]), 1),
    _createElementVNode("p", null, "Room id : " + _toDisplayString(_unref(roomId)), 1),
    _createVNode(_component_ui_btn, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(send)('GAME_RESET')))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_ui_btn, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(send)('GAME_BACK_HOME')))
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_ui_btn, {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(send)('GAME_RESTART')))
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    (_unref(state).matches('end.initial'))
      ? (_openBlock(), _createBlock(_component_ui_btn, {
          key: 0,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(send)('GAME_ACTION_DONE')))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(state).matches('end.initial'))
      ? (_openBlock(), _createBlock(_component_ui_btn, {
          key: 1,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(send)('EXIT_SESSION')))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(state).matches('end.success'))
      ? (_openBlock(), _createBlock(_component_ui_btn, {
          key: 2,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(send)('EXIT_SESSION')))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(state).matches('intro'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_ui_btn, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(send)('GAME_INTRO_ENDED')))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(state).matches('tuto.xr.move_around'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_ui_btn, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(send)('GAME_ACTION_DONE')))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(state).matches('tuto.xr.crouch'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_ui_btn, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(send)('GAME_ACTION_DONE')))
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(state).matches('tuto.xr.door'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_ui_btn, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(send)('GAME_ACTION_DONE')))
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(state).matches('tuto.xr.actions'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _hoisted_21,
          _createVNode(_component_ui_btn, {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(send)('GAME_ACTION_DONE')))
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(state).matches('tuto.xr.exit_room'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _hoisted_24,
          _createVNode(_component_ui_btn, { onClick: exitGuestRoom }, {
            default: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(state).matches('tuto') || _unref(state).matches('game'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _hoisted_27,
          _createVNode(_component_ui_btn, {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(send)('GAME_SEND_EMOJI')))
          }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(state).matches('game'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((hotspotSelected).value = $event))
          }, [
            _hoisted_30,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentHotspots), (h) => {
              return (_openBlock(), _createElementBlock("option", {
                key: h.id,
                value: h.id
              }, _toDisplayString(_unref(t)(`hotspots.${h.name}.label`)), 9, _hoisted_31))
            }), 128))
          ], 512), [
            [_vModelSelect, hotspotSelected.value]
          ]),
          _createVNode(_component_ui_btn, { onClick: clickHotspot }, {
            default: _withCtx(() => [
              _hoisted_32
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(state).matches('game'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("p", null, "You have " + _toDisplayString(_unref(state).context.countdown) + " sec to leave the house", 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})